import buildUUID from '../utils/buildUUID.js'

class Point{
  constructor(obj){
    const { id, url, name, pixelSize, color, opacity, outline, outlineColor, outlineOpacity, outlineWidth, maxDistance, minDistance, clampToGround, highlight, highlightOpacity, highlightColor, outlineHL, outlineOpacityHL, outlineWidthHL, outlineColorHL, crs, flyTo } = obj
    this._id = id ? id : buildUUID()
    this._url = url ? url : ''
    this._name = name ? name : 'point'
    this._highlight = highlight
    this._highlightOptions = {
      type: 'click',
      opacity: highlightOpacity !== null ? highlightOpacity : 1.0,
      color: highlightColor ? highlightColor : '#3388ff',
      outline: outlineHL || false,
      outlineOpacity: outlineOpacityHL !== null ? outlineOpacityHL : 1.0,
      outlineWidth: outlineWidthHL !== null ? outlineWidthHL : 3,
      outlineColor: outlineColorHL ? outlineColorHL : '#ffffff'
    }
    this._styleOptions = {
      pixelSize: pixelSize !== null ? pixelSize : 1,
      color: color ? color : '#ff0000',
      opacity: opacity !== null ? opacity : 1.0,
      outline: outline || false,
      outlineColor: outlineColor ? outlineColor : '#00ff00',
      outlineOpacity: outlineOpacity !== null ? outlineOpacity : 1.0,
      outlineWidth: outlineWidth !== null ? outlineWidth : 1.0,
      distanceDisplayCondition: true,
      distanceDisplayCondition_far: maxDistance !== null ? maxDistance : 9999999999999,
      distanceDisplayCondition_near: minDistance !== null ? minDistance : 1.0,
      clampToGround: clampToGround || false,
      highlight: this._highlight ? this._highlightOptions : {}
    }
    this._symbol = {
      type: 'pointP',
      styleOptions: this._styleOptions
    }
    this._crs = crs ? crs : 'EPSG:4326'
    this._flyTo = flyTo ? flyTo : false
    this._initObj = {
      id: this._id,
      url: this._url,
      name: this._name,
      symbol: this._symbol,
      crs: this._crs,
      flyTo: this._flyTo
    }
  }
}

Point.prototype.addToMap = function(map){
  console.log('执行addToMap!!!')
  var geojsonLayer = new mars3d.layer.GeoJsonLayer(this._initObj);
  map.addLayer(geojsonLayer);
}

export default Point